import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LucideIconData } from 'lucide-angular/icons/types';
import { NgClass } from '@angular/common';
import { TitleCasePipe } from '@angular/common';

@Component({
	selector: 'mos-icon-button',
	standalone: true,
	imports: [
		CommonModule,
		LucideAngularModule,
		MatTooltipModule,
		NgClass,
		TitleCasePipe,
	],
	templateUrl: './icon-button.component.html',
})
export class IconButtonComponent {
	@Input() public disabled: boolean = false;
	@Input() public icon: LucideIconData;
	@Input() public label: string;
	@Input() public iconSize: string; // class string eg. - 'tw-size-5'
	@Input() public padding: string = 'tw-p-2';

	@Output() public clicked: EventEmitter<void> = new EventEmitter();
}
